import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'sp-login',
  standalone: true,
  template: '',
})
export class LoginComponent implements OnInit {
  constructor(private auth: AuthService) {}
  ngOnInit(): void { this.auth.redirectToLogin(); }
}
